import React from 'react';
import ProfileGenerique from '../profile/ProfileGenerique';

export default function ProfileInfirmier() {
    return <ProfileGenerique role="infirmier" title="🏥 Mon profil infirmier" color="from-rose-600 to-pink-600" />;
}